import React from 'react';
import { Col, Row } from '@vds/grids';
import { TextLink } from '@vds/buttons';
import PropTypes from 'prop-types';

import '../cart.css';
import { Title, Body } from '../../../../../common/Typography/index';
import { apiUrls } from '../../../../../../constants/apiUrl';
import { getFlowType, isMobile, isMVA, getLTEUpgrade } from '../../../../../common/Helpers/index';
import { getProductRefData } from '../../../../../../utils/plansReference';
import { goToProcessStep } from '../../../../../../redirection';
import { mvaLinkApiCall } from '../../../../../common/MVAApiCall';
import IPILink from '../../../../../NextGen/ImportantPlanInfo/index';

const DueMonthly = (props) => {
  let planInfo = '';
  const editCartItem = () => {
    goToProcessStep(props.currentView, props.history, false, false, true);
  };

  const broadBandInfoClick = () => {
    if (isMVA()) {
      mvaLinkApiCall(apiUrls().mfAppBroadBandUrl);
    } else {
      window.open(apiUrls().broadBandUrl, '_blank');
    }
  };

  const renderHTMLContent = (SDList, plansReferenceData, pageName) => {
    const { ltePlans, broadbandInfoTitle } = props;
    const dueTodayListObj = props?.dueTodayList?.deviceItem;
    planInfo = dueTodayListObj && getProductRefData(dueTodayListObj?.sorId, dueTodayListObj?.productId, plansReferenceData);
    let imageUrl = '';
    if (dueTodayListObj?.imageUrlMap?.largeImage) {
      imageUrl = dueTodayListObj?.imageUrlMap?.largeImage;
    } else if (planInfo && planInfo.length > 0) {
      imageUrl = planInfo[0].cartImageUrl;
    }

    planInfo = getProductRefData(SDList?.sorId, SDList?.pricePlanCode, plansReferenceData);
    let planName;
    if (SDList?.pricePlanDisplayName) {
      planName = SDList.pricePlanDisplayName;
    } else if (planInfo && planInfo.length > 0) {
      if (getFlowType() === 'LTE') {
        planName = planInfo[0].cart_Mly_lte;
      } else {
        planName = planInfo[0].cart_Mly_5g;
      }
    }

    if (ltePlans && ltePlans.plans && ltePlans.plans.length > 0 && ltePlans.plans[0].planSorId) {
      planInfo = getProductRefData(ltePlans.plans[0].planSorId, 0, plansReferenceData)?.[0];
    }

    return (
      <div>
        {planName && (
          <Row>
            <Col xs={9}>
              <div className="plansArea">
                <img className="dueTodayItemImage" src={imageUrl} alt="" />
                <div>
                  <Body size="small">Plan</Body>
                  <div className={`${isMobile() ? '' : 'marginTop4'}`}>
                    <Title size="medium" primitive="h3">
                      {planName}
                    </Title>
                  </div>
                  <div className="marginTop4">
                    <div className="screen-reader-only">
                      <Body primitive="p" size="large" bold>
                        {` Due Monthly  $${parseFloat(SDList?.planPriceWithDiscount).toFixed(2)}`}
                      </Body>
                    </div>
                    <div aria-hidden="true">
                      <Body primitive="p" size="large" aria-hidden="true">
                        <span className="fontWight400">
                          ${parseFloat(SDList?.planPriceWithDiscount)}
                          /mo
                        </span>
                      </Body>
                    </div>
                    {getLTEUpgrade() && planInfo?.sorId && planInfo?.currentPlan && planInfo?.sorId === planInfo?.[0]?.sorId ? (
                      <div className="pad8 hellooo onlyLeftPad">{planInfo?.currentPlan}</div>
                    ) : null}
                    <div className={`linkSection ${isMobile() ? 'marginTop30' : 'marginTop8'}`}>
                      <Body size="small">
                        <IPILink />
                      </Body>
                      {broadbandInfoTitle && (
                        <div className={`${isMobile() && 'marginTop10'}`}>
                          <Body size="small">
                            <TextLink
                              id="broadbandInfoTitleLink"
                              data-track='{"type": "link",  "name": "5G-importantPlanInformation"}'
                              analyticstrack="5G-importantPlanInformation"
                              onClick={() => broadBandInfoClick()}
                              onKeyPress={() => broadBandInfoClick()}
                              className=""
                              ariaLabel="Important broadband information  opens in a new tab"
                            >
                              <span className="fontWight400">{broadbandInfoTitle}</span>
                            </TextLink>
                          </Body>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={3} className={`linkSection ${isMobile ? 'contentEnd marginTop6' : 'contentCenter marginTop24'}`}>
              {pageName === 'cart' && getFlowType() !== '' && (
                <Body size="large">
                  <TextLink
                    type="standAlone"
                    onClick={() => editCartItem()}
                    analyticstrack={`5G-addDevice_${SDList.name}`}
                    data-track="true"
                    ariaLabel={`${planName} plan Edit`}
                    id="Cart_Edit_Button"
                  >
                    <span className="fontWight400">Edit</span>
                  </TextLink>
                </Body>
              )}
            </Col>
          </Row>
        )}
      </div>
    );
  };

  const { cartDetails, plansReferenceData, pageName } = props;
  return (
    <>
      <div>{cartDetails && renderHTMLContent(cartDetails, plansReferenceData, pageName)}</div>
    </>
  );
};

DueMonthly.propTypes = {
  ltePlans: PropTypes.any,
  currentView: PropTypes.object,
  history: PropTypes.object,
  dueTodayList: PropTypes.object,
  broadbandInfoTitle: PropTypes.string,
  plansReferenceData: PropTypes.object,
  pageName: PropTypes.string,
  cartDetails: PropTypes.object,
};
export default DueMonthly;
